import { isBrowser } from '../lib/utils';

export let initialLimit = 4,
  limitForDay,
  sliderVisible;

if (isBrowser()) {
  // initialLimit = window.innerWidth < 1100 && window.innerWidth > 600 ? 3 : 4;
  limitForDay = window.innerWidth < 1023 && window.innerWidth > 600 ? 4 : 5;
  sliderVisible = window.innerWidth > 768;
}



// WEBPACK FOOTER //
// ./src/constants/limits.js